import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserBasicInfo } from '@app/models/basicInfo.model';
import { User } from '@app/models/user.model';
import { ApiService } from '@app/services/api.service';
import { SelectUser } from '@app/store/data/data.classes';
import { DataSelectors } from '@app/store/data/data.selectors';
import { Select, Store } from '@ngxs/store';
import { mergeMap, Observable, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html'
})
export class InfoComponent implements OnInit, OnDestroy {
  @Select(DataSelectors.selectedUser) user$!: Observable<User>;

  userList!: User[];
  userBasicInfo$!: Observable<UserBasicInfo>;

  private onDestory$: Subject<void>;

  constructor(
    private route: ActivatedRoute,
    private store: Store,
    private apiService: ApiService
  ) {
    this.onDestory$ = new Subject();
    this.userBasicInfo$ = this.user$.pipe(
      takeUntil(this.onDestory$),
      mergeMap((user) => this.apiService.getUserBasic(user.daicd))
    );
  }

  ngOnInit(): void {
    this.userList = this.route.snapshot.data['userList'];
  }

  ngOnDestroy(): void {
    this.onDestory$.next();
  }

  onUserChange(user: User) {
    this.store.dispatch(new SelectUser(user));
  }
}
